var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SideMenu,{staticClass:"sales-flyer-sidemenu",attrs:{"is-open":_vm.search != null,"menu-title":"Sales Flyer Deals"},on:{"close":function($event){return _vm.$emit('close')}}},[_c(_setup.SalesFlyerSideMenuContents,{attrs:{"search":_vm.search,"flyer-title":_vm.flyerTitle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }